import { render } from "./Breadcrumb.vue?vue&type=template&id=0432a8d8"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"
script.render = render

export default script